var styles = {"breakpoint-sm":"(min-width: 768px)","breakpointSm":"(min-width: 768px)","overlay":"styles_overlay__34DOi flex flex-column justify-end","modal":"styles_modal__2giXn flex flex-column","modalContent":"styles_modalContent__2Pz0P flex flex-column","closeContainer":"styles_closeContainer__1pWIL flex justify-center items-center absolute","close":"styles_close__1Bj9x"};

export default styles;
//# sourceMappingURL=styles.css.js.map
